import { Storage } from '@ionic/storage';
import { Injectable } from '@angular/core';

import 'rxjs/add/operator/map';
import { App } from 'ionic-angular';
import { ErrorPage } from '../../pages/error/error';

/*
  Generated class for the GlobalserviceProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class GlobalserviceProvider {
  myuser = {};
  public feedback_fit = '';
  userx:any;

  tokenEYD = '';
  // public storage: Storage;public app: App
  constructor() {
    //console.log('Hello GlobalserviceProvider Provider');
    
  }
  
}



// WEBPACK FOOTER //
// ./src/providers/globalservice/globalservice.ts